import { ConsumptionUnitEnum } from '../../../../enum/ConsumptionUnitEnum';
import { ReactComponent as InformationIcon } from '../../../../assets/information.svg';
import ModalForecastHistory from '../../../modals/ModalForecastHistory';
import { NumberUtils } from '../../../../common/numberUtils';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface ForecastHistoryTooltipProps {
  title: string;
  unit: ConsumptionUnitEnum;
  className?: string;
  hasInfo?: boolean;
  consumptionValue?: number;
  previsionValue?: number;
}
export default function ForecastHistoryTooltip({
  title,
  unit,
  className,
  hasInfo = true,
  consumptionValue,
  previsionValue,
}: ForecastHistoryTooltipProps) {
  const { t } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleClickAction = () => {
    setIsOpenModal(false);
  };

  const handleClickInfo = () => {
    setIsOpenModal(true);
  };
  return (
    <div className={classNames('forecast-history-tooltip', className)}>
      <div className="forecast-history-tooltip__header">
        <div className="forecast-history-tooltip__title">{title}</div>
        {hasInfo && (
          <InformationIcon onClick={handleClickInfo} className="icon icon--info icon--action" />
        )}
      </div>

      <div className="forecast-history-tooltip__content">
        <div className="forecast-history-tooltip__content__item">
          <div className="forecast-history-tooltip__content__item__value consumption">
            {NumberUtils.parse(consumptionValue, 2)}&nbsp;
            <span className="forecast-history-tooltip__content__item__unit">
              {ConsumptionUnitEnum.getSymbol(unit)}
            </span>
          </div>
          <div className="forecast-history-tooltip__content__item__label">
            {unit === ConsumptionUnitEnum.KWH
              ? t('overview.meter.detail.forecast.history.consumed')
              : t('overview.meter.detail.forecast.history.expensed')}
          </div>
        </div>
        <div className="forecast-history-tooltip__content__item">
          <div className="forecast-history-tooltip__content__item__value prevision">
            {NumberUtils.parse(previsionValue, 2)}&nbsp;
            <span className="forecast-history-tooltip__content__item__unit">
              {ConsumptionUnitEnum.getSymbol(unit)}
            </span>
          </div>
          <div className="forecast-history-tooltip__content__item__label">
            {t('overview.meter.detail.forecast.history.target')}
          </div>
        </div>
      </div>
      {hasInfo && <ModalForecastHistory isOpen={isOpenModal} onClickAction={handleClickAction} />}
    </div>
  );
}
